var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"color":"green darken-3","dark":""}},[_c('v-card-title',{staticClass:"text-caption"},[_c('span',{staticClass:"text-body-2"},[_vm._v("Ganancias ("+_vm._s(_vm.anio)+")")]),_c('v-spacer'),_c('v-chip',{attrs:{"color":"green darken-1"}},[_vm._v("$"+_vm._s(new Intl.NumberFormat("de-DE").format(_vm.utilidad)))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }